import { message } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { SystemRoleName } from '@evimo/types/enums/system-role-name';
import { useAuth } from '~/app/auth/context/AuthContext';
import {
  METIS_OCPP_LOGS_TRIGGER_ORGANIZATION_ID,
  triggerMetisOcppLogs,
} from '~/app/services/metis/metis-ocpp-logs.service';

export function useTriggerMetisOcppLogs() {
  const { user } = useAuth();
  const { t } = useTranslation('organization');
  const isSuperAdmin = user?.roleName === SystemRoleName.SUPER_ADMIN;

  const mutation = useMutation({
    mutationFn: () =>
      triggerMetisOcppLogs(METIS_OCPP_LOGS_TRIGGER_ORGANIZATION_ID),
    onSuccess: () => {
      message.success(t('messages.triggerMetisLogsSuccess'));
    },
    onError: (error: Error) => {
      message.error(error.message || t('messages.triggerMetisLogsFailed'));
    },
  });

  return {
    isSuperAdmin,
    isTriggeringMetisLogs: mutation.isPending,
    onTriggerMetisLogs: () => {
      if (!isSuperAdmin) {
        return;
      }
      mutation.mutate();
    },
  };
}
